/* eslint-disable */
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectDisplayLayout } from '@/store/slices/layoutSlice';
import { alpha, Box, CSSObject, Drawer, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import Scrollbar from '@/components/scrollbar/scrollbar';
import NavSection from '@/components/navSection/NavSection';
import sidebarConfig from '@/layouts/sidebar/SidebarConfig';
import sidebarConfigAdmin from "@/layouts/sidebar/SidebarConfigAdmin";
import { MHidden } from '@/components/@material-extend';
import { selectDrawer } from '@/store/slices/appSlice';
import Logo from '@/components/navSection/Logo';
import { selectCurrentUser } from "@/store/slices/authSlice";

const DRAWER_WIDTH = 170;

// const RootStyle = styled('div')(({ theme }) => ({
// 	[theme.breakpoints.up('lg')]: {
// 		flexShrink: 0,
// 		width: DRAWER_WIDTH,
// 		border: 'none'
// 	},
// 	backgroundColor: alpha('#fff', .1),
// }));

type SidebarProps = {
	isOpenSidebar: boolean;
	onCloseSidebar?: () => void;
};

const openedMixin = (theme: Theme): CSSObject => ({
	width: DRAWER_WIDTH,

	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),

	overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	//width: `calc(${theme.spacing(7)})`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(5)})`,
	},
});

const MuiDrawer = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
	width: DRAWER_WIDTH,
	flexShrink: 0,
	backgroundColor: alpha('#000', 0.1),
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',
	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}));

const Sidebar = ({ isOpenSidebar, onCloseSidebar }: SidebarProps): any => {
	const { sidebar } = useSelector(selectDisplayLayout);

	const drawer: boolean = useSelector(selectDrawer);

	//console.log('sidebar drawer ', drawer);

	const { pathname } = useLocation();

	const user: any = useSelector(selectCurrentUser);

	// obtener user role
	const role: string = user?.roles[0];

	let sidebarConfiguration: any[] = [];

	switch (true) {
		case (role && role !== "SuperAdminRole"):
			sidebarConfiguration = sidebarConfig;
			break;
		default:
			sidebarConfiguration = sidebarConfigAdmin;
			break;
	}
	//console.log(sidebarConfiguration);

	useEffect(() => {
		if (isOpenSidebar) {
			onCloseSidebar();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathname]);

	const renderContent = (
		<Scrollbar
			sx={{
				backgroundColor: alpha('#fff', 0.1),
				color: '#000',
				height: '100%',
				'& .simplebar-content': { height: '100%', display: 'flex', flexDirection: 'column' },
			}}
		>
			<Box
				sx={{
					px: 2.5,
					py: 3,
					...(!drawer && {
						px: 0,
					}),

				}}
			>
				<Box component={RouterLink} to="/" sx={{ display: 'inline-flex', textDecoration: 'none' }}>
					<Logo isOpenSidebar={drawer} />

				</Box>
			</Box>

			{/*<Box sx={{mb: 5, mx: 2.5}}>
                <Link underline="none" component={RouterLink} to="#">
                    account
                </Link>
            </Box>*/}

			<NavSection navConfig={sidebarConfiguration} />

			<Box sx={{ flexGrow: 1 }} />
		</Scrollbar>
	);

	if (!sidebar) return null;

	return (
		<>
			<MHidden width="lgUp">
				<Drawer
					open={isOpenSidebar}
					onClose={onCloseSidebar}
					PaperProps={{
						sx: { width: DRAWER_WIDTH },

					}}
				>
					{renderContent}
				</Drawer>
			</MHidden>

			<MHidden width="lgDown">
				<MuiDrawer
					anchor="left"
					open={drawer}
					variant="permanent"
					sx={{
						visibility: 'visible',
						transform: 'none',
					}}
				>
					{renderContent}
				</MuiDrawer>
			</MHidden>
		</>
	);
};

Sidebar.propTypes = {
	isOpenSidebar: PropTypes.bool,
	onCloseSidebar: PropTypes.func,
};

export default Sidebar;
